import { createTheme } from '@mui/material/styles';
import './tokens';

const darkTheme = createTheme({
  cssVariables: true,
  palette: {
    mode: 'dark',
    navigation: {
      background:        '#1F2335',
      subPanelBg:        '#3B415D',
      divider:           'rgba(255, 255, 255, 0.12)',
      tabSelectedBg:     '#1976D2',
      tabSelectedBorder: 'transparent',
      link:              '#3A8AF7',
      badge:             '#F73A5B',
      text:              '#FFFFFF',
      textMuted:         'rgba(255, 255, 255, 0.65)',
      subPanelText:      '#ffffff',
      subPanelTextMuted: 'rgba(255, 255, 255, 0.65)',
      subPanelAvatarBg:  'rgba(255, 255, 255, 0.2)',
    },
    surface: {
      appBackground:    '#3B4053',
      chatPanelBg:      '#3B4053',
      chatHeaderBg:     '#3B4053',
      inputBg:          '#3B4053',
      inputBorder:      'rgba(255, 255, 255, 0.18)',
      inputBorderFocus: '#3A8AF7',
      inputText:        'rgba(255, 255, 255, 0.85)',
      divider:          'rgba(255, 255, 255, 0.08)',
      primaryText:      '#FFFFFF',
      secondaryText:    'rgba(255, 255, 255, 0.65)',
      emptyStateIcon:   'rgba(255, 255, 255, 0.4)',
      toastBg:          '#ffffff',
      toastText:        '#1A1F2E',
    },
    chat: {
      userBubbleBg:          '#1976D2',
      userBubbleText:        '#FFFFFF',
      assistantBubbleBg:     '#2D3349',
      assistantBubbleBorder: 'rgba(255, 255, 255, 0.08)',
      bubbleText:            '#FFFFFF',
      sentStatus:            'rgba(255, 255, 255, 0.55)',
      reactionAction:        'rgba(255, 255, 255, 0.65)',
      reactionActionHover:   '#FFFFFF',
      systemBubbleBg:        'rgba(255, 255, 255, 0.06)',
    },
  },
  components: {
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: '#ffffff',
          color: '#1A1F2E',
          '& .MuiTypography-root': { color: '#1A1F2E' },
          '& .MuiInputLabel-root': { color: '#6B7280' },
          '& .MuiInputLabel-root.Mui-focused': { color: '#1565C0' },
          '& .MuiInputBase-input': { color: '#1A1F2E' },
          '& .MuiOutlinedInput-notchedOutline': { borderColor: '#D1D5DB' },
          '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#9AA0A6' },
          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1565C0' },
          '& .MuiButton-text': { color: '#1A1F2E' },
          '& .MuiButton-text:hover': { backgroundColor: 'rgba(0,0,0,0.04)' },
          '& .MuiDivider-root': { borderColor: 'rgba(0,0,0,0.12)' },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          color: '#1A1F2E',
        },
      },
    },
  },
  typography: {
    fontFamily: "'Proxima Nova', sans-serif",
  },
});

export default darkTheme;
